import { Tooltip } from '@/ui/rapid-ui/tooltip'
import { logger } from '@/ui/utilities/instrumentation/logger'
import { useState } from 'react'

export function CandidateBarChart(
	{ data, campaignId, status }: { data: number[]; campaignId: string; status: string },
) {
	const max = Math.max(...data, 1)
	const [tracked, setTracked] = useState(false)

	const handleMouseEnter = () => {
		if (!tracked) {
			setTracked(true)
			logger.track('Dashboard: Bar chart hovered', {
				data: { campaign_id: campaignId, campaign_status: status },
			})
		}
	}

	const today = new Date()

	return (
		<div className="flex items-end gap-0.5 h-9" onMouseEnter={handleMouseEnter}>
			{data.map((count, i) => {
				const date = new Date(today)
				date.setDate(today.getDate() - (data.length - 1 - i))
				const label = new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'short' }).format(date)

				const handleColumnHover = () => {
					logger.track('Dashboard: Bar chart day tooltip shown', {
						data: {
							campaign_id: campaignId,
							campaign_status: status,
							date: label,
							candidate_count: count,
						},
					})
				}

				return (
					<Tooltip
						key={i}
						content={`${label}: ${count} ${count === 1 ? 'candidate' : 'candidates'}`}
						placement="top"
						wrapperClassName="w-2 h-full flex items-end hover:bg-grey-100"
					>
						<div className="h-full flex items-end w-full" onMouseEnter={handleColumnHover}>
							<div
								className="w-full bg-green-600"
								style={{ height: `${count === 0 ? 3 : Math.max(6, Math.round((count / max) * 36))}px` }}
							/>
						</div>
					</Tooltip>
				)
			})}
		</div>
	)
}
